const SimpleFormatter = (formatter) => ({
  format(amount) {
    return [
      {
        value: formatter.format(amount),
        type: 'integer',
      },
    ];
  },
});

export default SimpleFormatter;
